import script from "./PrivacyPolicyPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrivacyPolicyPage.vue?vue&type=script&setup=true&lang=ts"

import "./PrivacyPolicyPage.vue?vue&type=style&index=0&id=0c83e1d3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c83e1d3"]])

export default __exports__